import { render, staticRenderFns } from "./VAllTasks.vue?vue&type=template&id=0e7228e0&"
import script from "./VAllTasks.vue?vue&type=script&lang=js&"
export * from "./VAllTasks.vue?vue&type=script&lang=js&"
import style0 from "./VAllTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports